import React from "react";

/** מדיניות פרטיות — עברית (עדכון אחרון: 17 באפריל 2026) */
const PrivacyHebrewBody: React.FC = () => (
  <>
    <p className="text-body leading-relaxed mb-8">
      MySipur (&quot;אנחנו&quot;) מכבדת את פרטיות המשתמשים ומתחייבת להגן על המידע האישי שלהם.
    </p>

    <section className="mb-8">
      <h2 className="text-xl font-bold text-heading mb-2">1. מידע שאנו אוספים</h2>
      <p className="text-body font-semibold mb-2">א. מידע שאתה מספק</p>
      <ul className="list-disc ps-6 space-y-1 text-body leading-relaxed mb-4">
        <li>תמונות</li>
        <li>טקסטים</li>
        <li>כתובת אימייל</li>
      </ul>
      <p className="text-body font-semibold mb-2">ב. מידע שנאסף אוטומטית</p>
      <ul className="list-disc ps-6 space-y-1 text-body leading-relaxed">
        <li>כתובת IP</li>
        <li>סוג דפדפן</li>
        <li>נתוני שימוש</li>
      </ul>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-bold text-heading mb-2">2. שימוש במידע</h2>
      <p className="text-body leading-relaxed mb-3">אנו משתמשים במידע רק לצורך:</p>
      <ul className="list-disc ps-6 space-y-1 text-body leading-relaxed mb-3">
        <li>הפעלת הפלטפורמה</li>
        <li>יצירת ספרים</li>
        <li>עיבוד באמצעות AI</li>
        <li>שיפור השירות</li>
      </ul>
      <p className="text-body leading-relaxed">אנו לא משתמשים במידע לשיווק.</p>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-bold text-heading mb-2">3. עיבוד באמצעות AI</h2>
      <ul className="list-disc ps-6 space-y-1 text-body leading-relaxed">
        <li>התוכן מעובד על ידי ספקי AI (כולל OpenAI)</li>
        <li>זה נדרש ליצירת התוכן</li>
        <li>המידע לא משמש לאימון מודלים</li>
      </ul>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-bold text-heading mb-2">4. אחסון מידע</h2>
      <ul className="list-disc ps-6 space-y-1 text-body leading-relaxed">
        <li>המידע נשמר ב־Cloudflare R2</li>
        <li>נשמר בצורה מאובטחת</li>
      </ul>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-bold text-heading mb-2">5. שמירה ומחיקה</h2>
      <ul className="list-disc ps-6 space-y-1 text-body leading-relaxed mb-3">
        <li>התוכן נמחק לאחר יצירת הספר</li>
        <li>אין התחייבות לשחזור</li>
      </ul>
      <p className="text-body leading-relaxed">ניתן לבקש מחיקה.</p>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-bold text-heading mb-2">6. שיתוף מידע</h2>
      <p className="text-body leading-relaxed mb-3">אין מכירה של מידע. שיתוף מתבצע רק עם:</p>
      <ul className="list-disc ps-6 space-y-1 text-body leading-relaxed">
        <li>ספקי AI</li>
        <li>ספקי שירות</li>
      </ul>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-bold text-heading mb-2">7. מידע על ילדים</h2>
      <p className="text-body leading-relaxed mb-3">הפלטפורמה מיועדת למבוגרים בלבד.</p>
      <p className="text-body leading-relaxed mb-3">בהעלאת תמונות של קטינים, אתה מאשר:</p>
      <ul className="list-disc ps-6 space-y-1 text-body leading-relaxed">
        <li>שאתה אפוטרופוס או</li>
        <li>שיש לך אישור מתאים</li>
      </ul>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-bold text-heading mb-2">8. אבטחה</h2>
      <p className="text-body leading-relaxed mb-3">אנו משתמשים באמצעי אבטחה סבירים, כולל:</p>
      <ul className="list-disc ps-6 space-y-1 text-body leading-relaxed mb-3">
        <li>הצפנה</li>
        <li>גישה מוגבלת</li>
      </ul>
      <p className="text-body leading-relaxed">אין מערכת מאובטחת לחלוטין.</p>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-bold text-heading mb-2">9. זכויות משתמש</h2>
      <p className="text-body leading-relaxed mb-3">ייתכן שיש לך זכות:</p>
      <ul className="list-disc ps-6 space-y-1 text-body leading-relaxed">
        <li>לגשת למידע</li>
        <li>למחוק מידע</li>
        <li>לתקן מידע</li>
      </ul>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-bold text-heading mb-2">10. משתמשים בינלאומיים</h2>
      <p className="text-body leading-relaxed">שימוש מחוץ לארה״ב הוא באחריות המשתמש.</p>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-bold text-heading mb-2">11. עדכונים</h2>
      <p className="text-body leading-relaxed">ייתכנו שינויים במדיניות זו.</p>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-bold text-heading mb-2">12. יצירת קשר</h2>
      <p className="text-body leading-relaxed">
        <a
          className="font-semibold text-brandNavy underline underline-offset-2 hover:text-brandOrange focus:outline-none focus:ring-2 focus:ring-brandOrange rounded"
          href="mailto:support@mysipur.app"
        >
          support@mysipur.app
        </a>
      </p>
    </section>
  </>
);

export default PrivacyHebrewBody;
